import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'Application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // const token = btoa(`${process.env.REACT_APP_UN}:${process.env.REACT_APP_PWD}`);
    // if (token) {
    //   // eslint-disable-next-line no-param-reassign
    //   config.headers = {
    //     ...config.headers,
    //     // Authorization: `Basic ${token}`,
    //     'Content-Type': 'application/json',
    //   };
    // }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      const loginUrl = '/login';
      if (window.location.href !== loginUrl) {
        window.location.href = loginUrl;
        return;
      }
    }
    // eslint-disable-next-line consistent-return
    return Promise.reject(error);
  },
);

export default axiosInstance;
